/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Subject_AriaInputs */

const en_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject of your message`)
};

const ar_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موضوع رسالتك`)
};

const bn_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার মেসেজের বিষয়`)
};

const de_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreff Ihrer Nachricht`)
};

const es_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asunto de tu mensaje`)
};

const fr_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objet de votre message`)
};

const pt_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assunto da sua mensagem`)
};

const zh_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的消息主题`)
};

const tr_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesajınızın konusu`)
};

const ru_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тема вашего сообщения`)
};

const pl_form_subject_aria = /** @type {(inputs: Form_Subject_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temat Twojej wiadomości`)
};

/**
* | output |
* | --- |
* | "Subject of your message" |
*
* @param {Form_Subject_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_subject_aria = /** @type {((inputs?: Form_Subject_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Subject_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_subject_aria(inputs)
	if (locale === "bn") return bn_form_subject_aria(inputs)
	if (locale === "de") return de_form_subject_aria(inputs)
	if (locale === "es") return es_form_subject_aria(inputs)
	if (locale === "fr") return fr_form_subject_aria(inputs)
	if (locale === "pt") return pt_form_subject_aria(inputs)
	if (locale === "zh") return zh_form_subject_aria(inputs)
	if (locale === "tr") return tr_form_subject_aria(inputs)
	if (locale === "ru") return ru_form_subject_aria(inputs)
	if (locale === "pl") return pl_form_subject_aria(inputs)
	return en_form_subject_aria(inputs)
});